var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 4.25L8.5 8.5L4.25 4.25",
    stroke: "black",
    strokeWidth: 0.708333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 8.5L8.5 12.75L4.25 8.5",
    stroke: "black",
    strokeWidth: 0.708333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleDown);
export default __webpack_public_path__ + "static/media/double-down.8806f7e891e18426dff99557fabeb4b1.svg";
export { ForwardRef as ReactComponent };